import { render, staticRenderFns } from "./RecognitionLog.vue?vue&type=template&id=39d731fe&scoped=true&"
import script from "./RecognitionLog.vue?vue&type=script&lang=js&"
export * from "./RecognitionLog.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionLog.vue?vue&type=style&index=0&id=39d731fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d731fe",
  null
  
)

export default component.exports